import { Grid, Box, Divider } from '@material-ui/core'

import { Page, Container } from 'components'

import {
  Menu,
  OnPage,
  ButtonBaseComponent,
  Title,
  Paragraph,
  Section,
} from '../../components'

import Subscriptions from 'images/documentation/platform/subscription.png'
import NewSubscription from 'images/documentation/platform/newSubscription.png'

import { routes } from 'Routes'

const SubscriptionPlatform = () => {
  const onPage = [
    ['#d-assinatura', 'Assinatura'],
    ['#d-novaAssinatura', 'Nova Assinatura'],
  ]
  // const Code = ({ children }) => {
  //   return (
  //     <span
  //       style={{
  //         backgroundColor: '#e2f4f9',
  //         border: '1px solid #63bbdb',
  //         textTransform: 'lowercase',
  //         padding: '1px',
  //         fontSize: '12px',
  //         fontWeight: 400,
  //         width: 'auto',
  //         borderRadius: '4px',
  //       }}
  //     >
  //       {children}
  //     </span>
  //   )
  // }

  return (
    <Page title="Assinatura">
      <Container maxWidth="md">
        <Box style={{ marginBottom: '40px' }}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <Menu />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Box style={{ marginBottom: '40px' }}>
                <Title variant="h5" id="d-assinatura" subtitle="Plataforma">
                  Assinatura
                </Title>
                <Paragraph>
                  A cobrança recorrente é um modelo de faturamento que se baseia
                  em pagamentos periódicos automáticos, geralmente mensal,
                  trimestral ou anual.
                  <br />
                  <br />
                  <img
                    src={Subscriptions}
                    width="100%"
                    style={{ border: '1px solid silver', borderRadius: '20px' }}
                    alt="Tela de assinaturas"
                  />
                  <br />
                  <br />
                  Na página de cobrança possui alguns elementos, como criação de
                  nova assinatura, barra de pesquisa, filtros, status da
                  assinatura e listagem de assinaturas e suas respectivas datas.
                </Paragraph>
              </Box>
              <Divider />
              <Section>
                <Title variant="h6" id="d-novaAssinatura">
                  Nova Assinatura
                </Title>
                <br />
                <br />
                <img
                  src={NewSubscription}
                  width="100%"
                  style={{ border: '1px solid silver', borderRadius: '20px' }}
                  alt="Tela de nova assinatura"
                />
                <br />
                <br />
                <Paragraph>
                  Na página de nova cobrança recorrente, é disponibilizado os
                  seguintes campos de preenchimento:
                  <br />
                  <br />
                  <b>Informações do cliente</b>
                  <Box ml={10}>
                    <ul>
                      <li>
                        Nome completo: Neste campo, será preenchido o nome
                        completo do cliente;
                      </li>
                      <li>
                        Documento(CPF/CNPJ): Neste campo, preenche o documento
                        CPF e CNPJ do cliente;
                      </li>
                      <li>
                        E-mail: Neste campo, será preenchido o e-mail do
                        cliente, aqui ele receberá o link que redireciona para o
                        checkout de pagamento;
                      </li>
                      <li>
                        Código: Neste campo, será adicionado o código de
                        cobrança para que possa ser identificado no futuro;
                      </li>
                    </ul>
                  </Box>
                  <br />
                  <br />
                  <b>Informações de pagamento/assinatura</b>
                  <Box ml={10}>
                    <ul>
                      <li>
                        Código de assinatura: Código de assinatura de cobrança
                        recorrente;
                      </li>
                      <li>
                        Planos: Selecione o plano com as configurações de
                        cobrança
                      </li>
                    </ul>
                  </Box>
                </Paragraph>
              </Section>
              <Divider />
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ButtonBaseComponent
                    nextName="Planos"
                    previousName="Cobrança Avulsa"
                    previousRoute={routes.documentation.chargePlatform}
                    nextRoute={routes.documentation.plansPlatform}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <OnPage page={onPage} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default SubscriptionPlatform
